
import { navigateTo, transformUrl } from 'bits/location'
import { Component, namespace, Prop, Vue } from 'bits/vue'
import OzBadge, { OzBadgeColorScheme } from 'library/v4/components/OzBadge.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import { PlansState, UpgradeSource } from 'vuexstore/modules/plans'

export enum Tier {
  Gold = 'Gold',
  Platinum = 'Platinum',
}

export enum PaymentSchedule {
  Monthly = 'Monthly',
  Annual = 'Annual',
}

const browser = namespace('browser')

@Component({ components: { OzBadge, OzContainedButton, OzIcon, OzLoadingSpinner } })
export default class PaymentScheduleTier extends Vue {
  @browser.Getter isSmallerThanTabletPortrait!: boolean
  @Prop() plans!: PlansState['plans']
  @Prop() isLoadingPlanInformation!: boolean
  @Prop() tier!: Tier
  @Prop() paymentSchedule!: PaymentSchedule
  @Prop({ default: true }) useTierColor!: boolean
  @Prop() upgradeSource!: UpgradeSource | null
  @Prop() postCheckoutRedirectUrl!: string

  OzBadgeColorScheme = OzBadgeColorScheme
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  PaymentSchedule = PaymentSchedule
  Tier = Tier

  get buttonColorScheme(): OzContainedButtonColorScheme {
    if (!this.useTierColor) {
      return this.isSmallerThanTabletPortrait
        ? OzContainedButtonColorScheme.Secondary
        : OzContainedButtonColorScheme.Primary
    }
    if (this.tier === Tier.Gold) return OzContainedButtonColorScheme.Orange
    return OzContainedButtonColorScheme.Green
  }

  navigateToCheckout(): void {
    const searchParams = new URLSearchParams({
      upgrade_source: this.upgradeSource || '',
      next: this.postCheckoutRedirectUrl,
    })
    if (this.tier === Tier.Gold && this.paymentSchedule === PaymentSchedule.Monthly)
      navigateTo(transformUrl(this.plans.gold.monthly.url!, { searchParams }))
    if (this.tier === Tier.Gold && this.paymentSchedule === PaymentSchedule.Annual)
      navigateTo(transformUrl(this.plans.gold.annual.url!, { searchParams }))

    if (this.tier === Tier.Platinum && this.paymentSchedule === PaymentSchedule.Monthly)
      navigateTo(transformUrl(this.plans.platinum.monthly.url!, { searchParams }))
    if (this.tier === Tier.Platinum && this.paymentSchedule === PaymentSchedule.Annual)
      navigateTo(transformUrl(this.plans.platinum.annual.url!, { searchParams }))
  }
}
